export enum AuthState {
    DomainHintAccess = "domainHintAccess",
    Idle = "idle",
    MsalLogin = "msalLogin",
    MsalRedirectHandle = "msalRedirectHandle",
    MainTokenRequest = "mainTokenRequest",
    LoggedOut = "loggedOut",
    Error = "error",
}
